module.exports = __webpack_public_path__ + "static/dev8-4c9d932e9f6357a0f1cae222e3b240a4.png";